import { RiDownloadLine } from 'react-icons/ri'
import { customerHelper } from '@tweddle-se-team/common/constants'
import { customerId } from '@/utils/env'

const { CUSTOMER_IDS } = customerHelper

const downloadIconByCustomer = {
  [CUSTOMER_IDS.TME]: null,
  [CUSTOMER_IDS.SUBARU]: null,
  [CUSTOMER_IDS.NORDICS]: RiDownloadLine
}

const DownloadIcon = ({ defaultIcon: DefaultIcon, ...props }) => {
  const Icon = downloadIconByCustomer[customerId] || DefaultIcon

  return <Icon {...props} />
}

export default DownloadIcon
